import { _trim, _isArray } from '../utils';
import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `requestsSelectors.js`);

const createRequestSelector = (request) => (state) => state.requests[request] || null;

const createIsLoading = (request) => {
  debug.enter(`createIsLoading`);
  debug.log(`  requests:`, request);
  return _isArray(request)
    ? (state) => request.some((req) =>
      (typeof req !== `object`)
        ? _isLoading(state.requests[req])
        : _isLoading(req))
    : (typeof request !== `object`)
      ? (state) => _isLoading(state.requests[request])
      : _isLoading(request)
};

const _isLoading = (request) => {
  debug.log(`     request:`, request);
  debug.log(`     _isLoading: ${!!request && request.loading}`);
  return !!request && request.loading;
};

const createDidError = (request) => {
  return _isArray(request)
    ? (state) => request.some((req) =>
      (typeof req !== `object`)
        ? _didError(state.requests[req])
        : _didError(req))
    : (typeof request !== `object`)
      ? (state) => _didError(state.requests[request])
      : _didError(request)
};

const _didError = (request) => {
  return !!request && request.error;
};

const getPageInfo = (request, state) => {
  if (!state.requests[request] ||
      state.requests[request].offset === undefined ||
      state.requests[request].count === undefined)
    return null;

  return _trim({
    offset: state.requests[request].offset,
    count: state.requests[request].count,
    total: state.requests[request].total,
  });
};

const createCanGetMore = (request) => {
  return typeof request !== `object`
    ? (state) => _canGetMore(state.requests[request])
    : _canGetMore(request)
};

const _canGetMore = (request) => {
  let isLoading = _isLoading(request);
  let didError = _didError(request);

  if (!request || isLoading || didError)
    return false;

  if (request.offset !== undefined &&
      request.count !== undefined) {
    if (request.total !== undefined) {
      return request.offset + request.count < request.total - 1;
    } else {
      // return request.offset < 1;
      if (request.offset < 1) {
        return true;
      } else throw Error(`_canGetMore() called with an offset of ${request.offset} and undefined total`);
    }
  } else {
    debug.log(`&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&& _canGetMore error --- offset ${request.offset}, count ${request.count}`);
  }

    


    //throw Error(`_canGetMore() called on non-paged request type: ${request.name}`);
};

export { getPageInfo,
  createRequestSelector,
  createCanGetMore,
  createIsLoading,
  createDidError,
}



// WEBPACK FOOTER //
// ./src/data/requests/requestsSelectors.js